import React from "react";
import { ListItem, ListItemIcon, ListItemText, Badge } from "@material-ui/core";
import {
	Home,
	ScheduleOutlined,
	ListAltOutlined,
	DirectionsRunOutlined,
	InventoryOutlined,
} from "@mui/icons-material";
import { ReactNode } from "react";
import { useMenuStyles, useMenuItemBadgeStyles } from "./DrawerMenuStyles";
import { navIndex, navIcon } from "../../utils/consts";
import clsx from "clsx";
const MenuItem: React.FC<{
	name: string;
	index: navIndex;
	selected: boolean;
	icon: navIcon;
	badgeContent?: ReactNode;
	onClick: (index: navIndex) => void;
}> = (props) => {
	const { name, index, selected, badgeContent, icon, onClick } = props;
	const styles = useMenuStyles();

	//Each menu item can have separate badge bg & text colors
	const menuItemBadgeStyles = useMenuItemBadgeStyles({
		bgColor: "#ff0000",
		textColor: "#fff",
	});
	const MenuItemIcon = () => {
		const className = selected ? styles.selectedIcon : styles.icon;
		switch (icon) {
			case "ScheduleOutlined":
				return <ScheduleOutlined titleAccess={name} className={className} />;
			case "ListAltOutlined":
				return <ListAltOutlined titleAccess={name} className={className} />;
			case "DirectionsRunOutlined":
				return <DirectionsRunOutlined titleAccess={name} className={className} />;
			case "InventoryOutlined":
				return <InventoryOutlined titleAccess={name} className={className} />;
			default:
				return <Home className={className} />;
		}
	};

	return (
		<ListItem
			button
			disableRipple
			className={clsx(styles.menuItem, {
				[styles.selectedMenuItem]: selected,
			})}
			onClick={() => onClick(index)}
		>
			<ListItemIcon>
				<MenuItemIcon />
			</ListItemIcon>
			<ListItemText
				primary={
					badgeContent ? (
						<>
							{name}
							<Badge
								badgeContent={badgeContent}
								classes={{
									badge: clsx(menuItemBadgeStyles.badge, menuItemBadgeStyles.badgeOnExpanded),
								}}
							></Badge>
						</>
					) : (
						name
					)
				}
				className={selected ? styles.selectedText : styles.text}
			/>
		</ListItem>
	);
};

export default MenuItem;
